module.exports = __webpack_public_path__ + "components/rewards/ski-line/static/icon-f3d1183ba1b355e5e04d345bdb063450.png";